export default "__VITE_ASSET__D$vNybZS__"